module.exports = __webpack_public_path__ + "img/openEye.4865bc13.svg";